import { config } from "../../appConfig";
import baseURLGlobal from "../../utils/util";
export const SOURCE_HOME = 'SOURCE_HOME';
export const SOURCE_WEBVIEW = 'SOURCE_WEBVIEW';
const base_Url = baseURLGlobal;

export const GET = 'GET';
export const POST = 'POST';
var url = new URL(window.location.href);

const token = url.searchParams.get('token');

export const makeApiCal = (action) => {
	// PARAMETERS - method, route, storeData, catchError, body
	switch (action.method) {
		case GET:
			return fetch(`${base_Url}/${action.route}`, {
				method: GET,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
			})
				.then((res) => res.json())
				.then((res) => {
					res?.status === 'success'
						? action.storeData(res?.data)
						: action.catchError(res.message);
				})
				.catch((err) => {
					action.catchError(err);
				});
		case POST:
			return fetch(`${base_Url}/${action.route}`, {
				method: POST,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
				body: JSON.stringify(action.body),
			})
				.then((res) => res.json())
				.then((res) => {
					res?.status === 'success'
						? action.storeData(res?.data)
						: action.catchError(res.message);
				})
				.catch((err) => action.catchError(err));
		default:
			return;
	}
};

export const directDeepLink = (url, source, showAlert) => {
	const action = {
		method: POST,
		route: 'v2/storeDeeplink',
		body: { deeplink: url },
		storeData: (e) => console.log(e),
		catchError: (e) => console.error(e),
	};
	switch (source) {
		case SOURCE_HOME:
			makeApiCal(action);
			window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
				JSON.stringify(url)
			);
			window?.mobile?.exceuteDeeplink(JSON.stringify(url));
			window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));
			break;
		case SOURCE_WEBVIEW:
			makeApiCal(action);
			window?.webkit?.messageHandlers?.onDeeplinkExecuted?.postMessage(
				`${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
			);
			// window?.mobile?.onDeeplinkExecuted(
			//   `${url?.screen},${url?.paramOne},${url?.paramTwo},${url?.paramThree}`
			// );
			window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));

			break;
		default:
			return;
	}
};
